<template>
    <div class="w-100">
        <b-col lg="12" md="12" sm="12">
        </b-col>
        <b-col lg="3" md="12" sm="12">
            <label for="id-tipo-dose-input" class="label_size_vacina font-weight-bold">Aplicação</label>
            <br/>
            <span>{{ value.type }}</span>
        </b-col>
        <b-col lg="12" md="12" sm="12" v-if="value.list.length > 1">
            <h5 class="mt-1 label_size_vacina font-weight-bolder">Configuração das doses</h5>
        <table
            class="table-view-dose mt-1 scroll-card"
        >
        <caption class="d-none">Configuração de Doses</caption>
        <thead>
            <tr>
            <th class="label_size_vacina pr-2" scope="col">Nome da Dose</th>
            <th class="label_size_vacina px-1 text-center" scope="col">Ordem</th>
            <th class="label_size_vacina px-2" colspan="2" scope="col">Idade Recomendada</th>
            <th class="label_size_vacina px-2" colspan="2" scope="col">Idade Limite</th>
            </tr>
        </thead>
        <tbody>
            <tr>
            <th scope="col"></th>
            <th scope="col"></th>
            <th class="text-center" scope="col">De</th>
            <th class="text-center" scope="col">Até</th>
            <th class="text-center" scope="col">De</th>
            <th class="text-center" scope="col">Até</th>
            </tr>
            <tr
            class="mb-1"
            v-for="(item, index) in value.list"
            :key="index"
            >
                <td>
                    {{ item.dose.descricao }}
                </td>
                <td class="text-center">
                    {{ item.order }}
                </td>
                <td class="text-center">
                    {{ item.numberSinceAgeRecomended }} {{ item.numberSinceAgeRecomended == 1 ? singlePeriod[item.sinceAgeRecomended] : item.sinceAgeRecomended }}
                </td>
                <td class="text-center">
                    {{ item.numberUntilAgeRecomended }} {{ item.numberUntilAgeRecomended == 1 ? singlePeriod[item.untilAgeRecomended] : item.untilAgeRecomended }}
                </td>
                <td class="text-center">
                    {{ item.numberSinceAgeLimit }} {{ item.numberSinceAgeLimit == 1 ? singlePeriod[item.sinceAgeLimit] : item.sinceAgeLimit }}
                </td>
                <td class="text-center">
                    {{ item.numberUntilAgeLimit }} {{ item.numberUntilAgeLimit == 1 ? singlePeriod[item.untilAgeLimit] : item.untilAgeLimit }}
                </td>
            </tr>
        </tbody>
        </table>
        </b-col>
        <b-col class="mt-2" lg="6" md="12" sm="12" v-if="value.list.length > 1">
            <div class="d-flex align-items-center justify-content-center justify-content-md-start">
                <label for="dose-input" class="label_size_vacina font-weight-bold col-5 pl-0">Intervalo até a próxima dose (aprazamento)</label>
                <span class="col-2">{{ value.interval }} {{ value.interval == 1 ? singlePeriod[value.intervalDateOption] : value.intervalDateOption }}</span>
            </div>
        </b-col>
    </div>
</template>

<script>
import { BCardBody, BRow, BCol, BFormInput, BFormTextarea, BButton, BPopover, BFormGroup, BInputGroup, BInputGroupAppend} from 'bootstrap-vue'
import vSelect from 'vue-select'
import Ripple from 'vue-ripple-directive'

export default {
name: 'DoseConfiguration',
components: {
    BCardBody,
    BRow,
    BCol,
    BFormInput,
    BFormTextarea,
    BButton,
    BInputGroup,
    BInputGroupAppend,
    BPopover,
    BFormGroup,
    vSelect
},
directives: {
    Ripple
},
props: {
  value: {
    type: Object,
    required: true
  }
},
data() {
    return {
        singlePeriod: {
            "dias": "dia",
            "meses": "mês",
            "anos": "ano"
        }
    }
},
}
</script>

<style lang="scss">
.table-view-dose > tbody > tr {
    border-bottom: 1px solid #eeededc5!important;
    line-height: 2rem;
}
.table-view-dose > tbody > tr:last-child {
  border-bottom: none;
}
.pr-2r {
    padding-right: 2rem !important;
}
</style>